class ModalTrigger extends HTMLElement {
  constructor() {
    super();
    this._modalId = this.getAttribute('modal-target');
    this._modal = null;
  }
  connectedCallback() {
    // Find the associated modal
    if (this._modalId) {
      this._modal = document.getElementById(this._modalId);
    }

    // Make sure it's focusable
    if (!this.getAttribute('tabindex')) {
      this.setAttribute('tabindex', '0');
    }
    if (!this.getAttribute('role')) {
      this.setAttribute('role', 'button');
    }

    // Add ARIA attributes for accessibility
    this.setAttribute('aria-haspopup', 'dialog');
    this.setAttribute('aria-expanded', 'false');

    // Add event listeners
    this.addEventListener('click', this._handleClick.bind(this));
    this.addEventListener('keydown', this._handleKeydown.bind(this));
  }
  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
    this.removeEventListener('keydown', this._handleKeydown);
  }
  _handleClick(event) {
    event.preventDefault();
    this._openModal();
  }
  _handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this._openModal();
    }
  }
  _openModal() {
    if (this._modal) {
      // Set aria-expanded to true when opening the modal
      this.setAttribute('aria-expanded', 'true');
      if (typeof this._modal.showModal === 'function') {
        this._modal.showModal();
      } else {
        // Fallback if the browser doesn't support native dialogs
        const modalComponent = this._modal.closest('modal-dialog');
        if (modalComponent && typeof modalComponent.open === 'function') {
          modalComponent.open();
        }
      }
    }
  }
}
customElements.define('modal-trigger', ModalTrigger);